<template>
  <div>
    <transition name="fade">
      <div class="contact-popup" v-if="contactPopup">
        <div class="close" @click="$parent.contactPopup = null">
          <img src="@/assets/img/close.svg" />
          <p>close</p>
        </div>
        <div class="offclick" @click="$parent.contactPopup = null"></div>
        <div class="details">
          <div class="form">
            <transition name="fade">
              <div v-if="status == 'form'">
                <h2>Contact Us For More Information:</h2>
                <div class="inputs">
                  <div class="input">
                    <label>Name</label>
                    <input type="text" v-model="contact.name" placeholder="Type Here..." />
                  </div>
                  <div class="input">
                    <label>Phone</label>
                    <input type="text" v-model="contact.phone" v-mask="'(###) ###-####'" />
                  </div>
                  <div class="input">
                    <label>Email</label>
                    <input type="email" v-model="contact.email" />
                  </div>
                  <div class="input full">
                    <label>Message</label>
                    <textarea v-model="contact.message" />
                  </div>
                </div>
              </div>
            </transition>
            <transition name="fade">
              <div v-if="status == 'success'">
                <h2>Your contact information was sent! We'll get back to you.</h2>
              </div>
            </transition>
          </div>
          <div class="text">
            <p class="errors" v-if="errors">
              Please enter a valid
              <span v-for="(err, i) in errors">
                {{
                err + (i == errors.length - 1 ? "." : ", ")
                }}
              </span>
            </p>
            <div class="navs" v-if="status == 'form'">
              <div
                @click="submitForm()"
                class="nav"
                :style="{
                  backgroundColor: client.color && client.color.primary
                    ? '#' + client.color.primary
                    : '#F26638',
                }"
              >
                <p>Submit</p>
                <img src="@/assets/img/next.svg" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import { db, auth, functions } from "@/config/firebaseInit";
import Vue from "vue";
import VueMask from "v-mask";
Vue.use(VueMask);
var moment = require("moment");
var tz = require("moment-timezone");

export default {
  name: "contactpopup",
  props: ["contactPopup", "pageName", "selected_home"],
  data() {
    return {
      client: this.$store.state.client,
      kiosk: this.$store.state.kiosk,
      contact: {
        name: null,
        phone: null,
        email: null,
        message: null
      },
      errors: null,
      status: "form",
      sendEmail: functions.httpsCallable("sendEmail")
    };
  },
  methods: {
    async submitForm() {
      if (this.validate()) {
        this.status = null;
        await db
          .collection("client")
          .doc(this.client.id)
          .collection("contact")
          .doc()
          .set({
            client_id: this.client.id,
            kiosk_id: this.kiosk.id,
            pageName: this.pageName,
            ...this.contact
          });
        this.sendEmail({
          template_name: "mhm-contact-request",
          to_email: [
            {
              email: this.client.email
                ? this.client.email
                : "andrew@emagid.com",
              type: "to"
            }
          ],
          global_merge_vars: [
            {
              name: "logoUrl",
              content: this.client.logo
                ? this.client.logo
                : "https://static.wixstatic.com/media/be455e_848fbdf38ba64bad82008aa9cd2c6455~mv2.png/v1/fill/w_640,h_138,al_c,q_85,usm_0.66_1.00_0.01/MHM-Logo-Horiz-Blk.webp"
            },
            {
              name: "name",
              content: this.contact.name
            },
            {
              name: "email",
              content: this.contact.email
            },
            {
              name: "phone",
              content: this.contact.phone
            },
            {
              name: "message",
              content: this.contact.message
            },
            {
              name: "property",
              content: this.selected_home.headline
            },
            {
              name: "kiosk",
              content: this.kiosk.name
            },
            {
              name: "client",
              content: this.client.name
            }
          ]
        });
        setTimeout(() => {
          this.status = "success";
        }, 500);
        setTimeout(() => {
          this.status = "form";
          this.contact = {
            name: null,
            phone: null,
            email: null,
            message: null
          };
          this.$parent.contactPopup = false;
        }, 10000);
      }
    },
    checkEmail() {
      var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      if (this.contact.email && re.test(this.contact.email.toLowerCase())) {
        return true;
      } else {
        return false;
      }
    },
    validate() {
      let errors = [];
      this.errors = null;
      for (var key in this.contact) {
        if (key == "email" && !this.checkEmail()) {
          errors.push(key);
        } else {
          if (!this.contact[key] && key != "message") {
            errors.push(key);
          }
        }
      }
      if (errors.length) {
        this.errors = errors;
        return false;
      } else {
        return true;
      }
    }
  },
  created() {},
  firestore() {
    return {};
  },
  watch: {}
};
</script>

<style lang="scss">
.contact-popup {
  position: fixed;
  top: 0;
  left: 0;
  background: rgba(0, 0, 0, 0.9);
  z-index: 10;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  padding: 150px;
  .offclick {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }
  .details {
    position: relative;
    z-index: 3;
    width: 100%;
    height: 100%;
    display: flex;
    background: white;
    padding: 75px;
    .form {
      width: 60%;
      h2 {
        color: black;
        font-size: 50px;
      }
    }
    .text {
      width: 40%;
      padding: 50px;
      padding-left: 100px;
      display: flex;
      flex-direction: column;
      justify-content: flex-end;
      padding-bottom: 0;
      position: relative;
      .navs {
        margin-top: 30px;
      }
      .errors {
        color: red;
        font-size: 18px;
        font-weight: bold;
        padding: 15px 20px;
        background: rgba(255, 0, 0, 0.15);
      }
    }
  }
}
</style>
